// collection Tabs ----------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll(
    '.collection-tab, .collection-group__view-all'
  );

  const allView = document.getElementById('all-collections-view');
  const singleView = document.getElementById('single-collection-view');
  const productGridContainer = document.getElementById('ProductGridContainer');

  const cache = {};
  const productDataCache = {};

  // Prefetch collections
  tabs.forEach((tab) => {
    const handle = tab.dataset.handle;
    const url = tab.dataset.url;

    if (handle === 'all' || !url) return;

    fetch(url + '?section_id=' + window.sectionId)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const grid = doc.querySelector('#product-grid');

        if (grid) {
          cache[handle] = grid.outerHTML;
        }
      })
      .catch(() => {});
  });

  function showLoading() {
    productGridContainer.style.opacity = '0.4';
    productGridContainer.style.pointerEvents = 'none';
    productGridContainer.style.transition = 'opacity 0.2s ease';
  }

  function hideLoading() {
    productGridContainer.style.opacity = '1';
    productGridContainer.style.pointerEvents = '';
  }

  function renderGrid(html) {
    singleView.innerHTML = `<div class="collection">${html}</div>`;
  }

  // Set active tab by handle
  function setActiveTab(handle) {
    const allTabs = document.querySelectorAll('.collection-tab');

    allTabs.forEach((tab) => {
      tab.classList.remove('active');

      if (tab.dataset.handle === handle) {
        tab.classList.add('active');
      }
    });
  }

  // Fetch product data (tags + price)
  function attachProductData(handle, url) {
    return new Promise((resolve) => {
      if (productDataCache[handle]) {
        applyProductData(productDataCache[handle]);
        resolve();
        return;
      }

      fetch(url + '.json?limit=250')
        .then((r) => r.json())
        .then((data) => {
          const products = data.products || [];
          const map = {};

          products.forEach((p) => {
            map[p.id] = {
              tags: (p.tags || []).join(',').toLowerCase(),
              price: parseFloat(p.variants[0].price || '0'),
              title: p.title,
            };
          });

          productDataCache[handle] = map;

          applyProductData(map);

          resolve();
        })
        .catch(() => resolve());
    });
  }

  function applyProductData(map) {
    const cards = singleView.querySelectorAll('.grid__item');

    cards.forEach((card) => {
      const link = card.querySelector('a[href*="/products/"]');

      if (!link) return;

      const handle = link.href
        .split('/products/')[1]
        ?.split('?')[0];

      if (!handle) return;

      const product = Object.values(map).find(
        (p) =>
          p.title
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-') === handle
      );

      if (product) {
        card.dataset.tags = product.tags;
        card.dataset.price = product.price;
        card.dataset.title = product.title;
      }
    });

    // Re-run filters
    if (typeof window.runTagFilter === 'function') {
      window.runTagFilter();
    }
  }

  // Main click handler
  tabs.forEach((tab) => {
    tab.addEventListener('click', function (e) {
      e.preventDefault();

      const handle = this.dataset.handle;
      const url = this.dataset.url;

      // Set active tab
      setActiveTab(handle);

      // Reset tag filter
      if (typeof window.resetTagFilter === 'function') {
        window.resetTagFilter();
      }

      // ALL collections view
      if (handle === 'all') {
        singleView.style.display = 'none';
        allView.style.display = '';

        if (typeof window.runTagFilter === 'function') {
          window.runTagFilter();
        }

        return;
      }

      // Cached collection
      if (cache[handle]) {
        allView.style.display = 'none';

        renderGrid(cache[handle]);

        singleView.style.display = '';

        attachProductData(handle, url);

        return;
      }

      // Fetch collection
      showLoading();

      allView.style.display = 'none';
      singleView.style.display = 'none';

      fetch(url + '?section_id=' + window.sectionId)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(
            html,
            'text/html'
          );

          const grid = doc.querySelector('#product-grid');

          if (grid) {
            cache[handle] = grid.outerHTML;

            renderGrid(grid.outerHTML);

            singleView.style.display = '';

            attachProductData(handle, url);
          }

          hideLoading();
        })
        .catch((err) => {
          console.error('Error:', err);
          hideLoading();
        });
    });
  });
});

// collection listing ----------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function () {
    const items = document.querySelectorAll('.collection-list');

    function loadCollection(url) {
      fetch(url + '?view=ajax')
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newContent = doc.querySelector('#product-grid');
          const currentContent = document.querySelector('#product-grid');

          if (newContent && currentContent) {
            currentContent.innerHTML = newContent.innerHTML;
          }
        })
        .catch((err) => console.error('Error loading collection:', err));
    }

    items.forEach((item) => {
      item.addEventListener('click', function () {
        const url = this.getAttribute('data-url');
        if (!url) return;

        window.location.href = url;
      });
    });

    window.addEventListener('popstate', function () {
      loadCollection(window.location.pathname);
    });
});



// collection filters ----------------------------------------------------------------

// document.addEventListener('DOMContentLoaded', function () {
//   const tagBtns = document.querySelectorAll('.tag-filter-btn');
//   const sortSel = document.getElementById('tag-sort-select');
//   const countEl = document.getElementById('tag-product-count');
//   const noMsg = document.getElementById('no-products-message');
//   const resetBtn = document.getElementById('reset-filter-btn'); // ✅ NEW

//   let activeTag = 'all';
//   let activeSort = 'default';

//   function getCards() {
//     const allView = document.getElementById('all-collections-view');
//     const singleView = document.getElementById('single-collection-view');
//     const singleVisible =
//       singleView.style.display !== 'none' && singleView.innerHTML.trim() !== '';

//     const viewEl = singleVisible ? singleView : allView;
//     return Array.from(viewEl.querySelectorAll('.grid__item'));
//   }

//   function filterAndSort() {
//     const cards = getCards();
//     let visible = [];

//     cards.forEach((card) => {
//       const tags = (card.dataset.tags || '')
//         .toLowerCase()
//         .split(',')
//         .map((t) => t.trim());

//       const price = parseFloat(card.dataset.price || '0');

//       let show = false;

//       if (activeTag === 'all') {
//         show = true;
//       } else if (activeTag === 'under-15') {
//         show = price < 15;
//       } else if (activeTag === 'under-20') {
//         show = price < 20;
//       } else {
//         show = tags.some((t) => t === activeTag || t.includes(activeTag));
//       }

//       card.style.display = show ? '' : 'none';

//       if (show) {
//         visible.push({
//           el: card,
//           price,
//           title: (card.dataset.title || '').toLowerCase(),
//         });
//       }
//     });

//     // Sorting
//     if (activeSort !== 'default') {
//       const grids = new Set(visible.map((v) => v.el.parentElement));

//       grids.forEach((grid) => {
//         const gridItems = visible.filter((v) => v.el.parentElement === grid);

//         gridItems.sort((a, b) => {
//           if (activeSort === 'price-asc') return a.price - b.price;
//           if (activeSort === 'price-desc') return b.price - a.price;
//           if (activeSort === 'title-asc') return a.title.localeCompare(b.title);
//           if (activeSort === 'title-desc') return b.title.localeCompare(a.title);
//           return 0;
//         });

//         gridItems.forEach((v) => grid.appendChild(v.el));
//       });
//     }

//     // Update count
//     if (countEl) {
//       countEl.textContent =
//         visible.length + ' tool' + (visible.length !== 1 ? 's' : '');
//     }

//     // Show / hide "No products" message
//     if (noMsg) {
//       noMsg.style.display = visible.length === 0 ? 'block' : 'none';
//     }

//     // Hide empty collection groups (ONLY in ALL view)
//     const allView = document.getElementById('all-collections-view');
//     const singleView = document.getElementById('single-collection-view');
//     const isAllViewActive = singleView.style.display === 'none';

//     if (isAllViewActive) {
//       const groups = allView.querySelectorAll('.collection-group');

//       groups.forEach((group) => {
//         const groupCards = group.querySelectorAll('.grid__item');
//         let hasVisible = false;

//         groupCards.forEach((card) => {
//           if (card.style.display !== 'none') {
//             hasVisible = true;
//           }
//         });

//         group.style.display = hasVisible ? '' : 'none';
//       });
//     }
//   }

//   // Expose globally
//   window.runTagFilter = filterAndSort;

//   window.resetTagFilter = function () {
//     activeTag = 'all';
//     activeSort = 'default';

//     // Reset buttons
//     tagBtns.forEach((b) => b.classList.remove('active'));
//     const allBtn = document.querySelector('.tag-filter-btn[data-tag="all"]');
//     if (allBtn) allBtn.classList.add('active');

//     // Reset sort dropdown
//     if (sortSel) sortSel.value = 'default';

//     filterAndSort();
//   };

//   // Tag click
//   tagBtns.forEach((btn) => {
//     btn.addEventListener('click', function () {
//       tagBtns.forEach((b) => b.classList.remove('active'));
//       this.classList.add('active');

//       activeTag = this.dataset.tag;
//       filterAndSort();
//     });
//   });

//   // Sort change
//   if (sortSel) {
//     sortSel.addEventListener('change', function () {
//       activeSort = this.value;
//       filterAndSort();
//     });
//   }

//   // ✅ Reset button click (NEW)
//   if (resetBtn) {
//     resetBtn.addEventListener('click', function () {
//       if (typeof window.resetTagFilter === 'function') {
//         window.resetTagFilter();
//       }
//     });
//   }

//   // Initial run
//   filterAndSort();
// });


// collection tab slider ----------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".collectionSwiper", {
    slidesPerView: "auto",
    spaceBetween: 0,
    freeMode: true,
    loop: true,
    grabCursor: true,
    navigation: {
      nextEl: ".collection-next",
      prevEl: ".collection-prev",
    },
  });
});